import { FC } from 'react'

import { FocusNodeProps } from '@please/lrud/dist/types'

import { Button } from '@/components/Button/Button'
import { ButtonProps } from '@/components/Button/types'
import { focusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { openEventVideo } from '@/containers/EventDetailPage/Buttons/openEventVideo'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { WatchButtonProps } from './types'

export const WatchButton: FC<WatchButtonProps> = ({
  isLive,
  event,
  text,
  isPPVPopup,
  eventVideoSources,
}) => {
  const { t } = useCommonTranslation()

  const buttonProps: ButtonProps & FocusNodeProps = {
    focusId: focusIds.WATCH_NOW,
    onClick: () => openEventVideo(event, eventVideoSources),
    iconSrc: isLive ? icons.controls.play : icons.controls.replay,
    text: isLive ? t('watchNow') : t('startReplay'),
  }

  if (isPPVPopup) {
    buttonProps.focusId = 'PPV_popup' + focusIds.WATCH_NOW
    buttonProps.iconSrc = ''
    buttonProps.text = text || ''
  }

  return <Button {...buttonProps} />
}
